import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";

@Injectable()
export class FineSettingsService {
  baseUrl: string = environment.api_base_url;
  constructor(public http: HttpClient) {}

  getFines(params = {}): any {
    return this.http.get(`${this.baseUrl}fineRules`, {
      params: Object.entries(params)
        .filter(([key, val]) => val)
        .reduce((obj, [key, val]) => {
          obj[key] = val;
          return obj;
        }, {}),
    });
  }

  getFine(id, params = {}): any {
    return this.http.get(`${this.baseUrl}fineRules/${id}`, {
      params,
    });
  }

  addFine(payload = {}): any {
    return this.http.post(`${this.baseUrl}fineRules`, payload);
  }

  importFines(data) {
    return this.http.post(
      `${this.baseUrl}fineRules/import`,
      JSON.stringify(data)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/financial-settings/components/fines/fine-settings.service.ts